/**
 * Form definitions. Each field: { name, label, type, required, options, span, placeholder }.
 * type: text | email | tel | select | textarea | checkbox. span: "full" for full-width.
 * When adding or renaming a field, update the matching hidden form in /public/forms.html (Netlify Forms).
 */

const COUNTRY_HINT = "e.g. Germany, Brazil, UAE";

const contactBasics = [
  { name: "name", label: "Name", type: "text", required: true, autoComplete: "name" },
  { name: "company", label: "Company", type: "text", required: true, autoComplete: "organization" },
  { name: "role", label: "Role", type: "text", autoComplete: "organization-title" },
  { name: "email", label: "Email", type: "email", required: true, autoComplete: "email" },
  { name: "phone", label: "Phone / WhatsApp", type: "tel", autoComplete: "tel" },
  { name: "country", label: "Country", type: "text", required: true, placeholder: COUNTRY_HINT, autoComplete: "country-name" },
];

const consent = {
  name: "consent",
  type: "checkbox",
  required: true,
  span: "full",
  label: "I agree that SPC may store these details and contact me about this enquiry, as described in the privacy policy.",
};

export const sourcingForm = {
  type: "sourcing",
  submitLabel: "Send enquiry",
  fields: [
    ...contactBasics,
    { name: "enquiry_type", label: "Enquiry type", type: "select", required: true, options: ["API", "Ingredient", "FDF tender", "Other"] },
    { name: "product_name", label: "Product or ingredient name", type: "text", required: true },
    { name: "cas_number", label: "CAS number (optional)", type: "text", placeholder: "e.g. 50-78-2" },
    { name: "grade", label: "Grade or pharmacopoeia", type: "select", options: ["USP", "EP", "IP", "BP", "In-house", "Not sure"] },
    { name: "quantity", label: "Required quantity", type: "text", placeholder: "e.g. 250" },
    { name: "unit", label: "Unit", type: "select", options: ["g", "kg", "MT", "L", "Units"] },
    { name: "delivery_location", label: "Target delivery location", type: "text", placeholder: "City, country" },
    { name: "intended_use", label: "Intended use", type: "select", required: true, options: ["Pharma", "Cosmetic", "Nutraceutical", "Research"] },
    { name: "message", label: "Message", type: "textarea", span: "full", placeholder: "Specifications, timelines, documentation needed (COA, MSDS, DMF, CEP)..." },
    consent,
  ],
};

export const rndForm = {
  type: "rnd",
  submitLabel: "Send project brief",
  fields: [
    ...contactBasics,
    {
      name: "project_type",
      label: "Project type",
      type: "select",
      required: true,
      options: [
        "Formulation development",
        "Analytical method development",
        "Permeation and delivery studies",
        "Stability",
        "Prototype and pilot batches",
        "Regulatory dossier support",
        "Multiple / not sure",
      ],
    },
    { name: "stage", label: "Stage", type: "select", required: true, options: ["Idea or concept", "Early research", "Formulation", "Preclinical", "Pilot or scale-up", "Regulatory filing"] },
    {
      name: "target_market",
      label: "Target market",
      type: "select",
      options: ["Global", "Europe", "LATAM", "MENA", "Russia and CIS", "India", "South East Asia", "Korea", "ANZ", "USA / Other"],
    },
    { name: "budget", label: "Budget range", type: "select", options: ["Under USD 25k", "USD 25k to 100k", "USD 100k to 250k", "Over USD 250k", "Not yet defined"] },
    { name: "message", label: "Project summary", type: "textarea", span: "full", placeholder: "Molecule or concept, dosage form, key goals and timelines..." },
    consent,
  ],
};

export const contactForm = {
  type: "contact",
  submitLabel: "Send message",
  fields: [
    { name: "name", label: "Name", type: "text", required: true, autoComplete: "name" },
    { name: "company", label: "Company", type: "text", autoComplete: "organization" },
    { name: "email", label: "Email", type: "email", required: true, autoComplete: "email" },
    { name: "phone", label: "Phone / WhatsApp", type: "tel", autoComplete: "tel" },
    { name: "country", label: "Country", type: "text", placeholder: COUNTRY_HINT, autoComplete: "country-name" },
    {
      name: "topic",
      label: "Topic",
      type: "select",
      required: true,
      options: [
        "General enquiry",
        "API and ingredient sourcing",
        "Licensing: I have a product to license",
        "Licensing: I want to access a product for my market",
        "R&D / CRO",
        "Market entry",
        "Distribution partnership",
        "Other",
      ],
    },
    { name: "message", label: "Message", type: "textarea", required: true, span: "full" },
    consent,
  ],
};
